const Data = [
  {
    id: "1",
    title: "my Portfoilo website",
    category: "latest",
    price: "$1",
    img: "https://i.ibb.co/17LQC5X/Screenshot-48.png",
    desc: "I constructed my portfolio using React, JavaScript, Bootstrap, CSS, and React Styled Components",
    link: "https://www.mathiasvictor.com/",
  },
  {
    id: "2",
    title: "PeersApp landing page",
    category: "latest",
    price: "$1",
    img: "https://i.ibb.co/1XNW7YP/Screenshot-49.png",
    desc: "Tech stack: Nextjs, JavaScript, Bootstrap, CSS, and React Styled Components",
    link: "https://peersapp-3aigy7llz-portfolio-frontend-react-team-2.vercel.app/",
  },
  {
    id: "3",
    title: "Barter clone",
    category: "latest",
    price: "$1",
    img: "https://i.ibb.co/P6K4KTP/Screenshot-44.png",
    desc: "Tech stack: React, JavaScript, Bootstrap, CSS, and React Styled Components",
  },
  {
    id: "4",
    title: "Bubit URL shortener",
    category: "latest",
    price: "$1",
    img: "https://i.ibb.co/6ry4Lqn/Screenshot-46.png",
    desc: "Tech stack: React, JavaScript, Bootstrap, CSS, and React Styled Components",
    link: "https://bub-it.netlify.app/",
  },
  {
    id: "5",
    title: "Admin dashboard",
    category: "scripting",
    price: "$1",
    img: "https://i.ibb.co/sR5DTYV/Screenshot-50.png",
    desc: "Tech stack: React, JavaScript, Bootstrap, CSS, and React Styled Components",
    link: "https://admincapstone.netlify.app/#/Home",
  },
  {
    id: "6",
    title: "Quiz app",
    category: "scripting",
    price: "$1",
    img: "https://i.ibb.co/5nsNfvp/Screenshot-47.png",
    desc: "Tech stack: Nextjs, JavaScript, Bootstrap, CSS, and React Styled Components",

    link: "https://quiz-app-eight-zeta.vercel.app/",
  },
  {
    id: "7",
    title: "Styleteebera Hairs",
    category: "cms",
    price: "$1",
    img: "https://i.ibb.co/YpVSsDm/Screenshot-42.png",
    desc: "Tech stack: JavaScript, shopify, and CSS",
    link: "https://styleteebera.com/",
  },
  {
    id: "8",
    title: "Kidoclassic mall",
    category: "cms",
    price: "$1",
    img: "https://i.ibb.co/KqCTpps/Screenshot-43.png",
    desc: "Tech stack: JavaScript, shopify, and CSS",

    link: "https://kidoclassicmall.com/",
  },
  {
    id: "9",
    title: "Todo App",
    category: "scripting",
    price: "$1",
    img: "https://i.ibb.co/W2bV3p1/Screenshot-45.png",
    desc: "Tech stack: React, JavaScript, Bootstrap, CSS, and React Styled Components",
    link: "https://dockit-todo-app.vercel.app/index",
  },
  {
    id: "10",
    title: "Starbelly eats",
    category: "latest",
    price: "$1",
    img: "https://i.ibb.co/RpNMB87/Screenshot-51.png",
    desc: "Tech stack: React, JavaScript, Bootstrap, CSS, and React Styled Components",

    link: "https://vhickjr.github.io/starbelly/#/Contact",
  },
];

export default Data;
